module.exports = __webpack_public_path__ + "img/position-video.65141b60.png";